function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 108.8h283.9v-108.8h-283.9z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.3333 0 0 -1.3333 -38.511 105.91)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(182.19 68.564)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-2.675h-1.571v10.078h1.571v-5.319l3.872 5.319h1.711l-2.986-4.106 3.313-5.972h-1.82l-2.597 4.728z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(194.11 74.847)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.384-4.961h2.753zm4.075-8.958h-1.602l-0.746 2.675h-3.469l-0.746-2.675h-1.54l2.94 10.078h2.224z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(205.9 73.012)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.508-0.158 0.902-0.474 1.182-0.317 0.279-0.755 0.42-1.314 0.42h-1.851v-3.251h1.851c0.57 0 1.011 0.143 1.322 0.428s0.466 0.692 0.466 1.221m-3.639-3.002v-4.121h-1.571v10.078h3.437c1.026 0 1.843-0.26 2.45-0.778 0.606-0.518 0.909-1.234 0.909-2.146 0-0.716-0.173-1.314-0.521-1.797-0.347-0.482-0.847-0.821-1.501-1.018l2.395-4.339h-1.772l-2.193 4.121z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(217.08 67.226)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-1.337h-6.703v1.337h2.582v7.387h-2.535v1.353h6.609v-1.353h-2.535v-7.387z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(223.9 77.04)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.4l1.633 2.395 1.198-0.887zm-2.208-9.813h4.556v-1.338h-6.127v10.078h6.127v-1.353h-4.556v-2.94h3.872v-1.353h-3.872z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(234.38 73.012)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.508-0.158 0.902-0.474 1.182-0.317 0.279-0.755 0.42-1.314 0.42h-1.851v-3.251h1.851c0.57 0 1.011 0.143 1.322 0.428s0.466 0.692 0.466 1.221m-3.639-3.002v-4.121h-1.571v10.078h3.437c1.026 0 1.843-0.26 2.45-0.778 0.606-0.518 0.909-1.234 0.909-2.146 0-0.716-0.173-1.314-0.521-1.797-0.347-0.482-0.847-0.821-1.501-1.018l2.395-4.339h-1.772l-2.193 4.121z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(245.49 65.889)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.913l-3.312 8.041v-8.041h-1.384v10.078h1.897l3.328-8.056v8.056h1.384z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(252.35 77.04)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.4l1.633 2.395 1.198-0.887zm2.659-9.813v-1.338h-6.703v1.338h2.582v7.387h-2.535v1.353h6.609v-1.353h-2.534v-7.387z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(184.57 47.07)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.358 0-2.393 0.446-3.103 1.338-0.71 0.891-1.065 2.193-1.065 3.903 0 1.607 0.371 2.867 1.112 3.78 0.741 0.912 1.765 1.368 3.072 1.368 0.528 0 1.021-0.065 1.477-0.195 0.456-0.129 0.907-0.334 1.353-0.614l-0.716-1.228c-0.352 0.217-0.702 0.378-1.049 0.482-0.348 0.104-0.692 0.155-1.035 0.155-0.86 0-1.508-0.313-1.943-0.941-0.436-0.627-0.654-1.563-0.654-2.807 0-1.296 0.213-2.262 0.638-2.9s1.078-0.957 1.959-0.957c0.405 0 0.773 0.052 1.105 0.156 0.331 0.104 0.715 0.29 1.151 0.56l0.668-1.151c-0.435-0.311-0.907-0.547-1.415-0.708-0.508-0.16-1.026-0.241-1.555-0.241",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(191.94 48.564)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.557v-1.337h-6.128v10.077h6.128v-1.353h-4.557v-2.939h3.873v-1.353h-3.873z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(205.99 47.226)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.913l-3.312 8.041v-8.041h-1.384v10.078h1.897l3.328-8.056v8.056h1.384z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(213.17 55.951)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-8.725h-1.555v8.725h-3.033v1.353h7.621v-1.353z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(224.04 54.349)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.508-0.158 0.902-0.474 1.182-0.317 0.279-0.755 0.42-1.314 0.42h-1.851v-3.251h1.851c0.57 0 1.011 0.143 1.322 0.428s0.466 0.692 0.466 1.221m-3.639-3.002v-4.121h-1.571v10.078h3.437c1.026 0 1.843-0.26 2.45-0.778 0.606-0.518 0.909-1.234 0.909-2.146 0-0.716-0.173-1.314-0.521-1.797-0.347-0.482-0.847-0.821-1.501-1.018l2.395-4.339h-1.772l-2.193 4.121z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(231.77 48.455)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.591 0 1.047 0.166 1.369 0.498 0.321 0.332 0.482 0.803 0.482 1.415v6.936h1.524v-6.936c0-0.996-0.309-1.794-0.926-2.395-0.616-0.601-1.433-0.902-2.449-0.902-1.026 0-1.854 0.301-2.48 0.902-0.628 0.601-0.941 1.399-0.941 2.395v6.936h1.57v-6.936c0-0.612 0.161-1.083 0.482-1.415 0.322-0.332 0.778-0.498 1.369-0.498",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(239.44 55.188)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-7.962h-1.384v10.077h1.82l1.959-5.07 1.928 5.07h1.804v-10.077h-1.384v7.962l-1.804-4.619h-1.135z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("path", {
  d: "m170.46 28.461h-1.6v47.5h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.861 38.756h-1.6v18.682h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.301 33.629h-1.6v18.689h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55.449 38.756h-1.6v18.682h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.155 28.5h-1.6v18.682h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.007 33.637h-1.6v18.682h1.6z",
  fill: "#00a499"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.954 75.926)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-2.706-10.078h-2.659l-2.706 10.078h1.944l2.13-8.569 2.116 8.569z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(40.064 79.254)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h1.602l0.918-1.058 0.917 1.058h1.555l-1.757-2.302h-1.478zm5.925-10.638c0-0.891-0.311-1.601-0.933-2.13s-1.467-0.794-2.534-0.794c-0.592 0-1.204 0.084-1.836 0.249-0.632 0.167-1.203 0.399-1.71 0.7l0.746 1.525c0.508-0.291 0.992-0.506 1.454-0.646 0.461-0.14 0.92-0.21 1.376-0.21 0.488 0 0.866 0.101 1.136 0.303 0.269 0.203 0.404 0.495 0.404 0.879 0 0.29-0.114 0.547-0.342 0.77s-0.736 0.5-1.524 0.832c-0.591 0.249-1.024 0.453-1.299 0.614s-0.51 0.329-0.707 0.505c-0.301 0.27-0.524 0.573-0.669 0.911-0.145 0.336-0.218 0.712-0.218 1.127 0 0.84 0.301 1.522 0.902 2.045s1.394 0.786 2.38 0.786c0.57 0 1.13-0.076 1.679-0.226 0.55-0.15 1.073-0.366 1.571-0.645l-0.684-1.509c-0.477 0.249-0.926 0.435-1.346 0.56-0.419 0.124-0.827 0.186-1.22 0.186-0.426 0-0.76-0.098-1.004-0.295-0.243-0.197-0.365-0.456-0.365-0.777 0-0.291 0.117-0.55 0.35-0.778s0.749-0.519 1.548-0.871c0.569-0.26 0.989-0.467 1.259-0.622 0.269-0.156 0.498-0.322 0.684-0.498 0.311-0.259 0.539-0.555 0.685-0.886 0.145-0.332 0.217-0.7 0.217-1.105",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53.983 68.881)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.487-0.153 0.842-0.458 1.065-0.307 0.223-0.792 0.334-1.455 0.334h-1.306v-2.877h1.4c0.611 0 1.067 0.122 1.368 0.366 0.301 0.243 0.451 0.614 0.451 1.112m-0.404 4.261c0 0.415-0.133 0.72-0.397 0.918-0.264 0.196-0.671 0.295-1.22 0.295h-1.198v-2.566h1.198c0.538 0 0.942 0.114 1.212 0.342s0.405 0.565 0.405 1.011m-4.697 2.784h3.312c1.037 0 1.851-0.218 2.442-0.653s0.887-1.048 0.887-1.835c0-0.529-0.132-0.991-0.397-1.385-0.264-0.394-0.64-0.694-1.127-0.901 0.632-0.187 1.111-0.48 1.438-0.879s0.49-0.894 0.49-1.485c0-0.913-0.314-1.631-0.941-2.155-0.628-0.523-1.469-0.785-2.527-0.785h-3.577z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.745 74.604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-8.725h-1.555v8.725h-3.033v1.353h7.621v-1.353z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(79 67.217)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.557v-1.337h-6.128v10.077h6.128v-1.353h-4.557v-2.939h3.873v-1.353h-3.873z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(90.373 65.724)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.358 0-2.393 0.446-3.103 1.338-0.71 0.891-1.065 2.193-1.065 3.903 0 1.607 0.371 2.867 1.112 3.78 0.741 0.912 1.765 1.368 3.072 1.368 0.528 0 1.021-0.065 1.477-0.195 0.456-0.129 0.907-0.334 1.353-0.614l-0.716-1.228c-0.352 0.217-0.702 0.378-1.049 0.482-0.348 0.104-0.692 0.155-1.035 0.155-0.86 0-1.508-0.313-1.943-0.941-0.436-0.627-0.654-1.563-0.654-2.807 0-1.296 0.213-2.262 0.638-2.9s1.078-0.957 1.959-0.957c0.405 0 0.773 0.052 1.105 0.156 0.331 0.104 0.715 0.29 1.151 0.56l0.668-1.151c-0.435-0.311-0.907-0.547-1.415-0.708-0.508-0.16-1.026-0.241-1.555-0.241",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(97.643 70.452)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-4.572h-1.571v10.077h1.571v-4.152h3.686v4.152h1.57v-10.077h-1.57v4.572z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(112.81 65.88)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.913l-3.312 8.041v-8.041h-1.384v10.078h1.897l3.328-8.056v8.056h1.384z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(122.33 67.217)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-1.337h-6.703v1.337h2.582v7.387h-2.535v1.353h6.609v-1.353h-2.535v-7.387z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(128.88 65.724)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c-1.358 0-2.393 0.446-3.103 1.338-0.71 0.891-1.065 2.193-1.065 3.903 0 1.607 0.371 2.867 1.112 3.78 0.741 0.912 1.765 1.368 3.072 1.368 0.528 0 1.021-0.065 1.477-0.195 0.456-0.129 0.907-0.334 1.353-0.614l-0.716-1.228c-0.352 0.217-0.702 0.378-1.049 0.482-0.348 0.104-0.692 0.155-1.035 0.155-0.86 0-1.508-0.313-1.943-0.941-0.436-0.627-0.654-1.563-0.654-2.807 0-1.296 0.213-2.262 0.638-2.9s1.078-0.957 1.959-0.957c0.405 0 0.773 0.052 1.105 0.156 0.331 0.104 0.715 0.29 1.151 0.56l0.668-1.151c-0.435-0.311-0.907-0.547-1.415-0.708-0.508-0.16-1.026-0.241-1.555-0.241",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(136.27 68.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-2.675h-1.571v10.078h1.571v-5.319l3.872 5.319h1.711l-2.986-4.106 3.313-5.972h-1.82l-2.597 4.728z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(148.45 77.031)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.4l1.633 2.395 1.198-0.887zm-0.716-2.193-1.384-4.961h2.753zm4.075-8.958h-1.602l-0.746 2.675h-3.469l-0.746-2.675h-1.54l2.94 10.078h2.224z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(70.998 48.446)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0.591 0 1.047 0.166 1.369 0.498 0.321 0.332 0.482 0.803 0.482 1.415v6.936h1.524v-6.936c0-0.996-0.309-1.794-0.926-2.395-0.616-0.601-1.433-0.902-2.449-0.902-1.026 0-1.854 0.301-2.48 0.902-0.628 0.601-0.941 1.399-0.941 2.395v6.936h1.57v-6.936c0-0.612 0.161-1.083 0.482-1.415 0.322-0.332 0.778-0.498 1.369-0.498",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(84.27 47.217)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h-1.913l-3.312 8.041v-8.041h-1.384v10.078h1.897l3.328-8.056v8.056h1.384z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(93.794 48.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-1.337h-6.703v1.337h2.582v7.387h-2.535v1.353h6.609v-1.353h-2.535v-7.387z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(103.36 57.295)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-2.814-10.078h-2.225l-2.815 10.078h1.633l2.318-8.849 2.317 8.849z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(107.68 48.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h4.557v-1.337h-6.128v10.077h6.128v-1.353h-4.557v-2.939h3.873v-1.353h-3.873z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(120.52 54.34)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.508-0.158 0.902-0.474 1.182-0.317 0.279-0.755 0.42-1.314 0.42h-1.851v-3.251h1.851c0.57 0 1.011 0.143 1.322 0.428s0.466 0.692 0.466 1.221m-3.639-3.002v-4.121h-1.571v10.078h3.437c1.026 0 1.843-0.26 2.45-0.778 0.606-0.518 0.909-1.234 0.909-2.146 0-0.716-0.173-1.314-0.521-1.797-0.347-0.482-0.847-0.821-1.501-1.018l2.395-4.339h-1.772l-2.193 4.121z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(131.34 48.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-1.337h-6.594v0.886l4.556 7.838h-4.479v1.353h6.439v-0.902l-4.541-7.838z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(140.53 48.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-1.337h-6.703v1.337h2.582v7.387h-2.535v1.353h6.609v-1.353h-2.535v-7.387z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(146.89 55.942)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-8.725h-1.555v8.725h-3.033v1.353h7.621v-1.353z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(154.46 56.175)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.384-4.961h2.753zm4.075-8.958h-1.602l-0.746 2.675h-3.469l-0.746-2.675h-1.54l2.94 10.078h2.224z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.821 33.641)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-1.327 0.173-2.302 0.521-2.924 0.347-0.622 0.889-0.933 1.625-0.933 0.747 0 1.293 0.306 1.641 0.918 0.347 0.611 0.521 1.56 0.521 2.846 0 1.306-0.174 2.273-0.521 2.9-0.348 0.628-0.894 0.941-1.641 0.941s-1.291-0.301-1.633-0.902-0.513-1.55-0.513-2.846m5.925-0.093c0-1.67-0.324-2.945-0.972-3.826s-1.583-1.322-2.807-1.322c-1.254 0-2.195 0.435-2.823 1.306-0.627 0.872-0.941 2.183-0.941 3.935 0 1.659 0.327 2.932 0.98 3.818 0.654 0.887 1.581 1.33 2.784 1.33 1.265 0 2.211-0.436 2.838-1.307 0.627-0.87 0.941-2.182 0.941-3.934",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(83.665 31.246)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0-0.861-0.306-1.55-0.917-2.068-0.612-0.519-1.437-0.778-2.473-0.778-0.581 0-1.177 0.083-1.789 0.249s-1.161 0.399-1.648 0.7l0.669 1.229c0.497-0.291 0.974-0.504 1.43-0.638 0.457-0.135 0.913-0.202 1.369-0.202 0.56 0 0.995 0.121 1.306 0.365s0.467 0.593 0.467 1.05c0 0.331-0.124 0.627-0.373 0.886s-0.799 0.57-1.649 0.934c-0.57 0.248-0.99 0.45-1.26 0.606-0.269 0.155-0.497 0.316-0.684 0.482-0.301 0.269-0.524 0.568-0.669 0.894-0.145 0.327-0.217 0.692-0.217 1.097 0 0.808 0.29 1.466 0.871 1.975 0.58 0.508 1.342 0.762 2.286 0.762 0.549 0 1.088-0.073 1.617-0.218s1.042-0.358 1.54-0.638l-0.623-1.228c-0.456 0.249-0.891 0.433-1.306 0.552-0.414 0.119-0.819 0.179-1.213 0.179-0.498 0-0.889-0.12-1.174-0.358-0.285-0.239-0.428-0.555-0.428-0.949 0-0.332 0.127-0.624 0.381-0.878 0.254-0.255 0.806-0.568 1.657-0.941 0.559-0.259 0.974-0.464 1.244-0.614 0.269-0.151 0.498-0.309 0.684-0.475 0.311-0.269 0.539-0.567 0.684-0.894 0.146-0.327 0.218-0.687 0.218-1.081",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(89.995 37.28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0v-8.725h-1.555v8.725h-3.033v1.353h7.621v-1.353z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(100.87 35.678)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0c0 0.508-0.158 0.902-0.474 1.182-0.317 0.279-0.755 0.42-1.314 0.42h-1.851v-3.251h1.851c0.57 0 1.011 0.143 1.322 0.428s0.466 0.692 0.466 1.221m-3.639-3.002v-4.121h-1.571v10.078h3.437c1.026 0 1.843-0.26 2.45-0.778 0.606-0.518 0.909-1.234 0.909-2.146 0-0.716-0.173-1.314-0.521-1.797-0.347-0.482-0.847-0.821-1.501-1.018l2.395-4.339h-1.772l-2.193 4.121z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(109.02 37.513)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.384-4.961h2.753zm4.075-8.958h-1.602l-0.746 2.675h-3.469l-0.746-2.675h-1.54l2.94 10.078h2.224z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(121.93 38.633)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-2.814-10.078h-2.225l-2.815 10.078h1.633l2.318-8.849 2.317 8.849z",
  fill: "#00a499"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(126.94 37.513)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0-1.384-4.961h2.753zm4.075-8.958h-1.602l-0.746 2.675h-3.469l-0.746-2.675h-1.54l2.94 10.078h2.224z",
  fill: "#00a499"
}))));

function SvgKclogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 301.51 68.047",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKclogo);
export default __webpack_public_path__ + "static/media/kclogo.8b88ec84.svg";
export { ForwardRef as ReactComponent };